import React, { useState } from 'react'
import { Box, Collapse, IconButton, ListItemButton, ListItemText, } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const TutorialsTreeMap = ({ tree, depth = 0, setActiveTutorialURI }) => {
  const [openNodes, setOpenNodes] = useState([]);

  const handleToggle = (index, node) => {
    const currentIndex = openNodes.indexOf(index);
    const newOpenNodes = [...openNodes];

    if (currentIndex === -1) {
      newOpenNodes.push(index);
    } else {
      newOpenNodes.splice(currentIndex, 1);
    }

    setOpenNodes(newOpenNodes);

    // Set active tutorial URI only if the node has a URI
    if (node.uri && setActiveTutorialURI) {
      setActiveTutorialURI(node.uri);
    }
  };

  return (
    <Box>
      {tree.map((node, index) => (
        <Box key={index}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <ListItemButton
              component="div"
              onClick={() => handleToggle(index, node)}
              sx={{ marginLeft: `${depth * 20}px` }}
              variant="subtitle1"
            >
              <ListItemText>
                {node.label}
              </ListItemText>
              {node.articles && (
                <IconButton onClick={() => handleToggle(index, node)}>
                  {openNodes.includes(index) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
              )}
            </ListItemButton>
          </Box>
          {node.articles && (
            <Collapse in={openNodes.includes(index)} timeout="auto" unmountOnExit>
              {/* Pass setActiveTutorialURI down to child nodes */}
              <TutorialsTreeMap tree={node.articles} depth={depth + 1} setActiveTutorialURI={setActiveTutorialURI} />
            </Collapse>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default TutorialsTreeMap